import * as React from 'react'
import './videoPlayer.scss'

interface VideoProps {
	url: string
}

const videoPlayer = (props: VideoProps) => {
	const videoRef = React.useRef<HTMLVideoElement | null>(null)

	// Video may not rerender if the src changes, so we need to manually reload
	React.useEffect(() => {
		if (videoRef.current) {
			videoRef.current.src = props.url
			videoRef.current.load()
		}
	}, [props.url])

	return (
		<video controls className="videoPlayer" ref={videoRef}>
			<source src={props.url} />
			<p>
				Your browser does not support HTML video. Here is a<a href={props.url}>link to the video</a> instead.
			</p>
		</video>
	)
}

export default videoPlayer
